import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { AppTheme } from "../../theme/App.theme";

const MUILoader = ({
    IsMiniLoader,
    Size,
    Thickness,
    Color,
}) => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: IsMiniLoader ? "200px" : "400px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress 
        size={Size || 50} 
        style={{color: Color || AppTheme.PRIMARY_COLOR }}
        thickness={Thickness || 4}
      />
    </div>
  );
};

export default MUILoader;
